// extracted by mini-css-extract-plugin
export default {"UserTimeInfo":"UserTimeInfo-module-d209e44dc3ef6db41840","date":"UserTimeInfo-module-af98afd5ba556637721b","time":"UserTimeInfo-module-ef95a5ce9236878e2122"};